module.exports = __webpack_public_path__ + "static/pr-op-real-updates@3x-9109914d0c0a4b7672a5924285cd571a.png";